import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FileDownloadService } from '../../shared/services/file-download.service';

@Injectable()
export class ApplicationLogsResource {
  fileDownloadService = inject(FileDownloadService);

  private _allExportLogs = '/services/system/admin/export-logs';
  private _todayExportLogs = '/services/system/admin/export-logs/today';
  private _allProxyExportLogs = '/services/microsoft/admin/zpc-logs/export-logs';
  private _todayProxyExportLogs = '/services/microsoft/admin/zpc-logs/export-logs/today';

  getAllLogs = (): Observable<void> => {
    return this.fileDownloadService.downloadFile(this._allExportLogs);
  };

  getTodaysExportLogs = (): Observable<void> => {
    return this.fileDownloadService.downloadFile(this._todayExportLogs);
  };

  getAllProxyLogs = (): Observable<void> => {
    return this.fileDownloadService.downloadFile(this._allProxyExportLogs);
  };

  getTodaysProxyLogs = (): Observable<void> => {
    return this.fileDownloadService.downloadFile(this._todayProxyExportLogs);
  };
}
